/**
 * Maps backend onboarding step names to frontend route names
 * @param {string} stepName - Backend step name (e.g., 'select_activity')
 * @returns {string} Frontend route name (e.g., 'onboarding_select_activity')
 */
export const getOnboardingRouteName = stepName => {
  const stepToRouteMap = {
    select_activity: 'onboarding_select_activity',
    create_bot: 'onboarding_create_bot',
    knowledge_sources: 'onboarding_knowledge_sources',
    review_info: 'onboarding_review_info',
    test_bot: 'onboarding_test_bot',
    publish_bot: 'onboarding_publish_bot',
  };

  return stepToRouteMap[stepName] || 'onboarding_select_activity';
};

/**
 * Maps backend step name to frontend path
 * @param {string} stepName - Backend step name
 * @returns {string} Frontend route path
 */
export const getOnboardingRoutePath = stepName => {
  const stepToPathMap = {
    select_activity: 'select-activity',
    create_bot: 'create-bot',
    knowledge_sources: 'knowledge-sources',
    review_info: 'review-info',
    test_bot: 'test-bot',
    publish_bot: 'publish-bot',
  };

  return stepToPathMap[stepName] || 'select-activity';
};

/**
 * Gets the onboarding redirect URL for a user based on their progress
 * @param {number} accountId - User's account ID
 * @param {string} lastStep - Last completed step from backend
 * @param {boolean} completed - Whether onboarding is completed
 * @returns {string|null} URL to redirect to, or null if onboarding is completed
 */
export const getOnboardingRedirectURL = (accountId, lastStep, completed) => {
  if (completed) {
    return null;
  }

  const routePath = getOnboardingRoutePath(lastStep);
  return `/app/accounts/${accountId}/onboarding/${routePath}`;
};
